import Accessibility from '@/lib/enums/propertyRequest/Accessibility'
import AvailableStartDate from '@/lib/enums/propertyRequest/AvailableStartDate'
import Financing from '@/lib/enums/propertyRequest/Financing'
import LivingSituation from '@/lib/enums/propertyRequest/LivingSituation'
import OutdoorArea from '@/lib/enums/propertyRequest/OutdoorArea'
import ResidentialArea from '@/lib/enums/propertyRequest/ResidentialArea'
import Surroundings from '@/lib/enums/propertyRequest/Surroundings'
import { i18n } from '@/plugins/i18n'

const localizedMap = (baseKey, keys) => Object.defineProperties({}, Object.fromEntries(keys.map(key => [
  key,
  { enumerable: true, get: () => i18n.t(`${baseKey}.${key}`) }
])))

export const AccessibilityLabels = localizedMap('enums.propertyRequest.accessibility', Object.values(Accessibility))
export const AvailableStartDateLabels = localizedMap('enums.propertyRequest.availableStartDate', Object.values(AvailableStartDate))
export const FinancingLabels = localizedMap('enums.propertyRequest.financing', Object.values(Financing))
export const LivingSituationLabels = localizedMap('enums.propertyRequest.livingSituation', Object.values(LivingSituation))
export const OutdoorAreaLabels = localizedMap('enums.propertyRequest.outdoorArea', Object.values(OutdoorArea))
export const ResidentialAreaLabels = localizedMap('enums.propertyRequest.residentialArea', Object.values(ResidentialArea))
export const SurroundingsLabels = localizedMap('enums.propertyRequest.surroundings', Object.values(Surroundings))
